export const VIDEO_TYPE = 'video';
export const AUDIO_TYPE = 'audio';
